/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-lonely-if */
/* eslint-disable max-lines */
import { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { differenceInYears } from 'date-fns';
import EliteImage from '../../../images/EliteAccImg1.png';

import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { getCustomerValidation, savePersonalInformation } from '../../../services/formService';
import { getEmailVerificationData, mobileValidation } from '../../../services/validationService';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import { PersonalInformationStyles as classes } from './PersonalInformationStyles';
import { handleChange } from './PersonalInfoUtils';
import Personal from './Personal';
import PersonalBundle from '../../Bundle/PersonalBundle';
import { dgiMapping } from '../../../services/dgiMapping';
import KnockOffModal from '../StepTwo/KnockOffModal';
import Layout from '../../Layout';
import NewLayout from '../../Bundle/NewLayout';
import {
  INVALID_FORMAT_ERR,
  MSG_COUNTRY_MODAL,
  PERSONAL_INFO,
  PERSONAL_INFO_HEAD,
  MANDATORY_FIELD_ERR,
  DIFFERENT_NUMBER_MESSAGE,
  HOME_VI,
  BODY_STYLE,
  PERCENT,
  VOUCHED_ELEMENT,
  INVALID,
  VALID,
  DOB_DAY,
  KNOCK_OFF_MSSG_BODY,
  MSG_VOUCHED_MODAL,
  PROGRESA_CONTIGO,
  PERSONAL_INFO_HEAD_PROG,
  ELITE_ACCOUNT_EN,
  LIBRE_AHORRA_BUNDLE,
  VOUCHED_ERROR,
  NOT_ELIGIBLE,
  NOT_ELIGIBLE_DESCRIPTION,
  AGE_LIMIT_CD_IRA,
  MODALTEXTHEADING,
} from '../../../constants';
import { productMapping } from '../../../services/productMapping';
import CommercialModal from '../../CommercialDeposit/CommercialModal';
import { saveKnockOffData } from '../../DGI/CommonFunctions';
import RetailImage1 from '../../../images/Retail_Image_1.png';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import SaveContinueModal from '../../Modal/SaveContinueModal';
import {
  checkInvalidMobileNumber,
  commonTernary,
  isBundle,
  isCDIraproduct,
  isSimilarIRAProducts,
  productsNotEligibleForUsAddress,
  yearCalculatorPR,
} from '../../commonCode';
import { identifyCustomerType } from '../UtilityFunctions';
import BundleErrorModal from '../../Modal/BundleErrorModal';
import { clearContext } from '../../clearContext';
import CDIRAModals from '../ProductQuestion/CDIRAModals';
import { handleApiEnviroment } from '../../../WebComponents/commonComponents/customUtils';

/** PersonalInformation is the parent comp rendered on UI as a screen 2 for normal account opening process and dgi product flow
Its child component is Personal  */
function PersonalInformation(props) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const [isValidating, setIsValidating] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [openCDIraModal, setOpenCDIraModal] = useState(false);
  const [cdIraModalContent, setCdIraModalContent] = useState('');
  const { history } = props;
  const {
    personalInformation,
    savedDataFlow,
    setPersonalInformation,
    personalInformationErrors,
    setPersonalInformationErrors,
    isScreenTwoDirty,
    setIsScreenTwoDirty,
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsFundingScreenDirty,
    setCurrentPage,
    contactInformation,
    location,
    language,
    productName,
    vouched,
    idUploadStatus,
    countryModal,
    vouchedFailModal,
    setVouchedIdErrorStatus,
    setCustomerType,
    setIsModalSaveLater,
    isModalSave,
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
    isModalSaveLater,
    addressInformation,
    isValidatingVouch,
    customerType,
    bundleErrorModal,
    setProductName,
    setProductType,
    setCardsList,
    setProductDataIRA,
    accessToken,
    flowTypeETB,
    setFlowTypeETB,
    cdFlowOffers,
    setApplicationId,
  } = leadGenerationContext;

  const date = yearCalculatorPR();

  useEffect(() => {
    if (personalInformation?.dob) {
      const year = new Date(personalInformation.dob).getFullYear();
      if (year && year <= 999) {
        setPersonalInformationErrors({ ...personalInformationErrors, dob: INVALID_FORMAT_ERR });
      }
    }
    if (personalInformationErrors.dob !== '* Invalid Date') {
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,
        dob: '',
      }));
    }
  }, [personalInformation.dob, personalInformationErrors.dob]);
  const handlePhoneEqual = () => {
    if (location === HOME_VI) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        altPhone: '',
      }));
    } else {
      const phoneNumber1 = `${contactInformation?.areaCode}${contactInformation.phone}`;
      const altPhoneNumber = `${personalInformation?.altAreaCode}${personalInformation?.altPhone}`
        ? personalInformation?.altPhone
        : '';
      if (phoneNumber1 !== altPhoneNumber) {
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          altPhone: '',
        }));
      }
    }
  };
  useEffect(() => {
    setCurrentPage(PERSONAL_INFO);

    if (productMapping(productName) !== PROGRESA_CONTIGO && !savedDataFlow) {
      if (contactInformation?.firstName !== personalInformation?.firstName) {
        setPersonalInformation((prevState) => ({
          ...prevState,
          firstName: contactInformation?.firstName,
        }));
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          firstName: '',
        }));
        setSaveAppContactInfo((prevState) => ({
          ...prevState,
          firstName: contactInformation?.firstName,
        }));
        setSaveAppContactInfoErrors((prevState) => ({
          ...prevState,
          firstName: '',
        }));
        setIsScreenTwoDirty(true);
        setIsScreenThreeDirty(true);
        setIsScreenFourDirty(true);
        setIsScreenFiveDirty(true);
        setIsFundingScreenDirty(true);
      }
      if (contactInformation?.lastName !== personalInformation?.lastName) {
        setPersonalInformation((prevState) => ({
          ...prevState,
          lastName: contactInformation?.lastName,
        }));
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          lastName: '',
        }));
        setSaveAppContactInfo((prevState) => ({
          ...prevState,
          lastName: contactInformation?.lastName,
        }));
        setSaveAppContactInfoErrors((prevState) => ({
          ...prevState,
          lastName: '',
        }));
        setIsScreenTwoDirty(true);
        setIsScreenThreeDirty(true);
        setIsScreenFourDirty(true);
        setIsScreenFiveDirty(true);
        setIsFundingScreenDirty(true);
      }

      if (contactInformation?.phone !== personalInformation?.altPhone) {
        handlePhoneEqual();
      }
    }
  }, []);
  useEffect(() => {
    document.body.className = BODY_STYLE;
    document.documentElement.style.height = PERCENT;
    vouched?.unmount(VOUCHED_ELEMENT);
    window.scrollTo(0, 0);
  }, []);

  let valid = true;

  const maritalStatusMandatoryCheck = () => {
    if (dgiMapping(leadGenerationContext.productName)) {
      if (!personalInformation?.maritalStatus) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          maritalStatus: MANDATORY_FIELD_ERR,
        }));
      }
      if (!personalInformation?.secondLastName) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          secondLastName: MANDATORY_FIELD_ERR,
        }));
      }
    }
  };
  const progresaContigoMandatoryChk = () => {
    if (productMapping(productName) === PROGRESA_CONTIGO) {
      if (!personalInformation?.phone) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          phone: MANDATORY_FIELD_ERR,
        }));
      }
      if (!personalInformation?.email) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          email: MANDATORY_FIELD_ERR,
        }));
      }

      if (personalInformation?.phone && !personalInformation?.areaCode) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          phone: INVALID_FORMAT_ERR,
        }));
      }
    }
  };
  /**
   * form fields mandatory check before save call */
  const isFormValid = () => {
    if (!personalInformation?.gender) {
      valid = false;
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        gender: MANDATORY_FIELD_ERR,
      }));
    }

    if (personalInformation?.dob.length < 10) {
      valid = false;
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: MANDATORY_FIELD_ERR,
      }));
    }
    if (!personalInformation?.ssn) {
      valid = false;
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        ssn: MANDATORY_FIELD_ERR,
      }));
    }
    maritalStatusMandatoryCheck();

    progresaContigoMandatoryChk();
    if (productMapping(productName) !== LIBRE_AHORRA_BUNDLE) {
      if (!personalInformation?.firstName) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          firstName: MANDATORY_FIELD_ERR,
        }));
      }
      if (!personalInformation?.lastName) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          lastName: MANDATORY_FIELD_ERR,
        }));
      }
      if (personalInformation?.altPhone && !personalInformation?.altAreaCode) {
        valid = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          altPhone: INVALID_FORMAT_ERR,
        }));
      }
      if (!(personalInformation?.vouchedJobId && idUploadStatus === true)) {
        if (process.env.REACT_APP_VOUCHED_ID_UPLOAD_ENABLE === 'true') {
          valid = false;
          setVouchedIdErrorStatus(true);
        }
      }
    }
    for (const key in personalInformationErrors) {
      if (personalInformationErrors[key]) {
        valid = false;
        break;
      }
    }
    return valid;
  };

  /**
   * Mobile number melisa validation for location VI & PR */
  let isValidAltPhone = false;
  let phoneNumber = null;
  let response = null;
  const phoneNumberLocation = async (areaCode, phone) => {
    if (location === 'VI') {
      phoneNumber = phone?.replace(/\D+/g, '');
      if (phoneNumber && phoneNumber?.length === 10) {
        response = await mobileValidation(phoneNumber, leadGenerationContext.accessToken);
      }
    } else {
      phoneNumber = `${areaCode}${phone}`;
      if (phoneNumber && phoneNumber?.length === 11) {
        response = await mobileValidation(phoneNumber, leadGenerationContext.accessToken);
      }
    }
  };
  /**
   * Invalid error message to display  */
  const altNumberValidCheck = (response1, errorToShowElement) => {
    if (response1.data[0] && response1.data[0]?.status === INVALID) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [errorToShowElement]: `* ${response1.data[0].message}`,
      }));
      const element = document.getElementById(errorToShowElement);
      if (element) {
        element.focus();
      }
    }
    if (response1.data[0] && response1.data[0]?.status === VALID) {
      isValidAltPhone = true;
      setPersonalInformation((prevState) => ({
        ...prevState,
        altPhoneValidationResponse: response1.data[0],
      }));
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [errorToShowElement]: '',
      }));
    }
  };

  const altMobileNumberValidCheck = (response1, errorToShowElement) => {
    if (response1 && response1.status === 200) {
      altNumberValidCheck(response1, errorToShowElement);
    }
  };
  const validateMobile = async (areaCode, errorToShowElement, phone, product) => {
    if (product === PROGRESA_CONTIGO) {
      if (phone) {
        await phoneNumberLocation(areaCode, phone);

        altMobileNumberValidCheck(response, errorToShowElement);
      }
    } else if (product !== PROGRESA_CONTIGO) {
      if (phone) {
        await phoneNumberLocation(areaCode, phone);

        altMobileNumberValidCheck(response, errorToShowElement);
      } else {
        isValidAltPhone = true;
      }
    }

    return {
      isAltPhoneValid: isValidAltPhone,
      validationResponse: response ? response?.data[0] : null,
    };
  };

  /**
   * Display invalid age error message to the date of birth field if user age less than 18 */
  const handleAgeRuleValidation = (message) => {
    if (message && message.length > 0) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: `* ${message}`,
      }));
      const element = document.getElementById(DOB_DAY);
      if (element) {
        element.focus();
      }
    } else {
      setPersonalInformationErrors((prevState) => ({ ...prevState, dob: '' }));
    }
  };

  const handleAgeRuleValidationCdIra = (errorMsg) => {
    if (
      Object.keys(errorMsg).length > 0 &&
      errorMsg.message === 'Customer is ineligible for both the years.'
    ) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: `* ${errorMsg.message}`,
      }));
      const element = document.getElementById(DOB_DAY);
      if (element) {
        element.focus();
      }
      setOpenCDIraModal(true);
      setCdIraModalContent({
        heading: 'You are not eligible to open a CD IRA',
        text1: 'Due to your age (75 or older), it is not possible to open a CD IRA account.',
        text2: 'Discover how our Certificates of Deposit can help your money grow.',
        alertIcon: true,

        button1: 'Learn more about CDs',
        button1OnClick: () => {
          window.open(
            'https://orientalbank.com/en/for-you/banking-accounts/certificates-of-deposit',
            '_blank'
          );
        },
        button2: 'Open a CD',
        button2OnClick: () => {
          clearContext(leadGenerationContext);
          setApplicationId(null);
          leadGenerationContext.setCdFlowOffers({
            depositAmount: '',
            minDepositAmount: 1000,
            offers: {},
            iraType: '',
          });
          leadGenerationContext.setAccessToken(accessToken);
          leadGenerationContext.setLanguage(language);
          setProductName('Certificate of Deposit');
          setProductType('Certificate of Deposit');
          setFlowTypeETB(flowTypeETB);
          history.push({
            pathname: `/${location?.toLowerCase()}/${language.toLowerCase()}/retail-form/${productNameURLMapping(
              'Certificate of Deposit'
            )}/certificate-of-deposit`,
          });
        },
      });
      saveKnockOffData(leadGenerationContext, AGE_LIMIT_CD_IRA);
    } else if (
      Object.keys(errorMsg).length > 0 &&
      errorMsg.message === 'Customer is ineligible for the previous year alone.'
    ) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: `* ${errorMsg.message}`,
      }));
      const element = document.getElementById(DOB_DAY);
      if (element) {
        element.focus();
      }
      setOpenCDIraModal(true);
      setCdIraModalContent({
        heading: 'You are only eligible to open a CD IRA for the previous tax year',
        text1:
          'Due to your age (75 or older), it is not possible to open a CD IRA for the current tax year.',
        text2: 'Click Continue to proceed with opening your CD IRA for the previous tax year.',
        button2: 'Continue',
        button2OnClick: () => {
          setCardsList([
            {
              text: `${date?.year - 1} tax year`,
              id: 'priorTaxYear',
            },
          ]);
          setProductDataIRA((prevState) => ({
            ...prevState,
            yearStatus: {
              text: `${date?.year - 1} tax year`,
              id: 'priorTaxYear',
            },
          }));
          setOpenCDIraModal(false);
        },
        onClose: () => {
          setOpenCDIraModal(false);
        },
      });

      saveKnockOffData(leadGenerationContext, AGE_LIMIT_CD_IRA);
    } else {
      setPersonalInformationErrors((prevState) => ({ ...prevState, dob: '' }));
    }
  };
  /**
   * Display error message to the alt phone field if user tries to enter same alt phone and mobile number */
  const handleSamePhoneAltPhoneValidation = (message) => {
    if (message && message.length > 0) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        altPhone: `* ${message}`,
      }));
      const element = document.getElementById('altPhone');
      if (element) {
        element.focus();
      }
    } else {
      setPersonalInformationErrors((prevState) => ({ ...prevState, altPhone: '' }));
    }
  };
  /**
   * call save api for dgi product and normal account opening products */
  const saveData = async (altPhoneValidation, emailValid) => {
    const data = { ...personalInformation };
    data.applicationId = leadGenerationContext.applicationId;
    data.language = leadGenerationContext.language;
    data.location = leadGenerationContext.location;
    data.utmCampaign = leadGenerationContext.utmCampaign;
    data.utmMedium = leadGenerationContext.utmMedium;
    data.utmContent = leadGenerationContext.utmContent;
    data.utmTerm = leadGenerationContext.utmTerm;
    data.utmSource = leadGenerationContext.utmSource;
    data.branchCode = leadGenerationContext.branchCode;
    data.productType = leadGenerationContext.productType;
    data.productName = leadGenerationContext.productName;
    data.altPhoneValidationResponse = altPhoneValidation;
    data.emailVerificationResponse = emailValid;
    data.vouchedAddressVerified = addressInformation.vouchedAddressVerified;
    data.addrLineOne = addressInformation.address1;
    data.addrLineTwo = addressInformation.address2;
    data.state = addressInformation.state;
    data.country = addressInformation.country;
    data.city = addressInformation.city;
    data.zipCode = addressInformation.zipCode;
    data.crossCheckResponse = leadGenerationContext.crossCheckResponse;
    data.dlvStatus = personalInformation.dlvStatus;
    data.salesAdvisor = leadGenerationContext.salesAdvisor;
    data.employer = leadGenerationContext.employmentInformation.employer;
    let response2 = null;
    response2 = await savePersonalInformation(data, leadGenerationContext.accessToken);

    return response2;
  };
  /**
   * Handle back button: Should be navigated back to Contact information(screen 1) */
  const handleBack = (e) => {
    e.preventDefault();
    // if (productName === 'Consumer Credit') {
    //   history.push(
    //     `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
    //       productName
    //     )}/loan-participant-info`
    //   );
    // } else {
    history.push(
      `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
        productName
      )}/contact-info`
    );
    // }
  };
  /**
   * Handle Save Application button: Should be navigated to Save Application Page */
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };

  /**
   * Focus check for mandatory fields of normal account opening products */
  let isElementFound = false;
  const productMapFocus = () => {
    if (!isElementFound) {
      const fieldList = ['firstName', 'lastName', 'gender', 'ssn', 'dob'];
      for (const field of fieldList) {
        if (!personalInformation[field]) {
          let element = null;
          if (field === 'dob') {
            element = document.getElementById(DOB_DAY);
          } else {
            element = document.getElementById(field);
          }
          if (element) {
            element.focus();
            break;
          }
        }
      }
    }
  };
  const handleFocusError = (fieldList) => {
    for (const field of fieldList) {
      if (!personalInformation[field]) {
        let element = null;
        if (field === 'dob') {
          element = document.getElementById(DOB_DAY);
        } else {
          element = document.getElementById(field);
        }
        if (element) {
          element.focus();
          break;
        }
      }
    }
  };
  /**
   * Focus check for mandatory fields of dgi product */
  const dgiFocusError = () => {
    if (dgiMapping(leadGenerationContext.productName)) {
      if (!isElementFound) {
        const fieldList = [
          'firstName',
          'lastName',
          'secondLastName',
          'gender',
          'ssn',
          'dob',
          'maritalStatus',
        ];
        handleFocusError(fieldList);
      }
    } else if (productMapping(leadGenerationContext.productName)) {
      productMapFocus();
    }
  };
  /**
   * Date of birth focus */
  const dobDayFocus = (field) => {
    let ele;
    if (field === 'dob') {
      ele = document.getElementById(DOB_DAY);
    } else {
      ele = document.getElementById(field);
    }
    return ele;
  };
  /**
   * ID Upload focus */
  const idUploadFocus = (idUploadStatus1) => {
    let ele = 'initialIdUploadImg';
    if (idUploadStatus1 === true) {
      ele = 'idUploadSuccessImg';
    } else if (idUploadStatus1 === false) {
      ele = 'idUploadFailImg';
    }
    return ele;
  };
  /**
   * Focus check for mandatory error personal fields */

  const personalFocusError = () => {
    let fields = [];
    if (productMapping(productName) === PROGRESA_CONTIGO) {
      fields = [
        'vouchedId',
        'firstName',
        'middleName',
        'lastName',
        'secondLastName',
        'gender',
        'areaCode',
        'phone',
        'email',
        'ssn',
        'dob',
      ];
    } else {
      fields = [
        'vouchedId',
        'firstName',
        'middleName',
        'lastName',
        'secondLastName',
        'gender',
        'altAreaCode',
        'altPhone',
        'ssn',
        'dob',
        'maritalStatus',
      ];
    }
    for (const field of fields) {
      if (
        field === 'vouchedId' &&
        (!personalInformation?.vouchedJobId || idUploadStatus === false) &&
        process.env.REACT_APP_VOUCHED_ID_UPLOAD_ENABLE === 'true'
      ) {
        let elementId = '';
        elementId = idUploadFocus(idUploadStatus);
        const element = document.getElementById(elementId);
        if (element) {
          isElementFound = true;
          element.focus();
          element.scrollIntoView();
          document.getElementById('uploadIdPassportTitle')?.scrollIntoView();
          break;
        }
      } else if (personalInformationErrors[field]) {
        let element = null;
        element = dobDayFocus(field);
        if (element) {
          isElementFound = true;
          element.focus();
          break;
        }
      }
    }
    dgiFocusError();
    setIsValidating(false);
  };
  /**
   * Check MinAge object for error message if backend throws when user enter dob which is less than 18 */
  const checkMinAge = (result) => {
    if ((result && result.data && result.data.MinAge) || result.data?.AgeValidation) {
      if (result.data.MinAge[0]?.message) {
        handleAgeRuleValidation(result.data.MinAge[0].message);
      }
      // else if (
      //   isCDIraproduct(productName) &&
      //   result.data?.AgeValidation[0]?.message &&
      //   result.data?.AgeValidation[0]?.rule === 'CD IRA Age validation'
      // ) {
      //   handleAgeRuleValidationCdIra(result.data.AgeValidation[0]);
      // }
    }
    /**
     * Check IdUpload object for error message if user fail to upload ID and proceed to continue */
    if (result && result.data && result.data.IdUpload) {
      if (result.data.IdUpload[0]?.message) {
        if (result.data.IdUpload[0].message === 'Upload your photo ID to open your account') {
          if (process.env.REACT_APP_VOUCHED_ID_UPLOAD_ENABLE === 'true') {
            setVouchedIdErrorStatus(true);
          }
        }
      }
    }
  };
  const isPhoneAltPhoneSame = (result) => {
    if (dgiMapping(productName)) {
      if (result && result.data && result.data.PersonalInfoDGI) {
        if (result.data.PersonalInfoDGI[0]?.rule === DIFFERENT_NUMBER_MESSAGE) {
          handleSamePhoneAltPhoneValidation(result.data.PersonalInfoDGI[0].message);
        }
      }
    } else if (result && result.data && result.data.PersonalInfo) {
      if (result.data.PersonalInfo[0]?.rule === DIFFERENT_NUMBER_MESSAGE) {
        handleSamePhoneAltPhoneValidation(result.data.PersonalInfo[0].message);
      }
    }
  };
  /**
   * With successful save status 201, If the flow is account opening process, it will be routed to address information screen(Screen 3) */
  const validateResult = (result) => {
    if (result && result.status === 201 && result.data.applicationId) {
      setPersonalInformation((prevState) => ({
        ...prevState,
        oldssn: personalInformation.ssn,
      }));
      leadGenerationContext.setApplicationId(result.data.applicationId);
      setIsScreenTwoDirty(false);
      setIsValidating(false);
      const nextScreen =
        isBundle(productName) && !personalInformation?.uploadSuccessStatus
          ? 'vouched-success'
          : 'address-info';

      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/${nextScreen}`
      );
    } else {
      checkMinAge(result);
      isPhoneAltPhoneSame(result);
      setIsValidating(false);
    }
  };
  const saveFinalData = async (altPhoneValidation, emailValid) => {
    const result = await saveData(
      altPhoneValidation?.validationResponse,
      emailValid?.validationData
    );
    validateResult(result);
  };

  const handleCustomerValidation = async (
    validCheck,
    customerValidation,
    altPhoneValidation,
    emailValid
  ) => {
    if (customerValidation && customerValidation.status === 200) {
      setIsValidating(true);
      if (customerValidation.data.Status === 'Success') {
        if (customerValidation.data.InvalidCustomer === 'false') {
          setIsModal(false);
          if (productMapping(productName) === PROGRESA_CONTIGO) {
            const validEmail = await emailValidation();
            await validationResult(validCheck, validEmail, altPhoneValidation);
          } else await saveFinalData(altPhoneValidation, emailValid);
        } else if (customerValidation.data.InvalidCustomer === 'true') {
          setIsModal(true);
          if (productMapping(productName) !== PROGRESA_CONTIGO) {
            const usersToString = customerValidation.data.ExceptionCode;
            await saveKnockOffData(leadGenerationContext, KNOCK_OFF_MSSG_BODY, '', usersToString);
          }
          setIsValidating(false);
        }
      }
    } else if (customerValidation?.status === 500) {
      setIsValidating(false);

      await saveFinalData(altPhoneValidation, emailValid);
    } else {
      setIsValidating(false);
    }
  };

  const getEmailErrorType = (errorMsg) => {
    const domainErrors = [
      'Email Domain Not Found',
      'Email Server Not Found',
      'Invalid Domain',
      'Unavailable Domain',
    ];
    const mailboxErrors = ['Invalid Email', 'Unknown Email'];
    for (const error of domainErrors) {
      if (error === errorMsg) {
        return 'Domain_Error';
      }
    }
    for (const error of mailboxErrors) {
      if (error === errorMsg) {
        return 'Mailbox_Error';
      }
    }
    return null;
  };

  let emailvalid = false;
  let emailErrorType = null;
  let emailValidationData = null;
  const validateEmailResponse = (resp) => {
    if (resp && resp.status === 200 && resp.data[0]) {
      const data = resp.data[0];
      if (data.status === 'Valid') {
        emailvalid = true;
        setPersonalInformationErrors((prevState) => ({ ...prevState, email: '' }));
      } else {
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          email: `* ${data.message}`,
        }));
        emailErrorType = getEmailErrorType(data.message);
      }
      emailValidationData = data;
    }
  };

  const emailValidation = async () => {
    if (personalInformationErrors.email === '* Invalid Format') {
      const emailElement = document.getElementById('email');
      emailElement.setSelectionRange(0, personalInformation.email?.length);
      emailElement.focus();
    } else if (personalInformation.email) {
      const emailResponse = await getEmailVerificationData(
        personalInformation.email,
        leadGenerationContext.accessToken,
        {
          isWCFlow: leadGenerationContext?.wcFlow,
          env: handleApiEnviroment(leadGenerationContext?.environment),
        }
      );
      validateEmailResponse(emailResponse);
      if (emailErrorType) {
        let emailhighlightStartIndex = 0;
        let emailhighlightEndIndex = 0;
        const emailElement = document.getElementById('email');
        if (emailErrorType === 'Mailbox_Error') {
          emailhighlightEndIndex = personalInformation.email.indexOf('@');
          emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
          emailElement.focus();
        }
        if (emailErrorType === 'Domain_Error') {
          emailhighlightStartIndex = personalInformation.email.indexOf('@') + 1;
          emailhighlightEndIndex = personalInformation.email.length;
          emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
          emailElement.focus();
        }
      }
    }
    return {
      valid: emailvalid,
      validationData: emailValidationData,
    };
  };

  const validationResult = async (validCheck, validationEmail, altPhoneValidation) => {
    if (
      validCheck &&
      validationEmail &&
      validationEmail?.valid === true &&
      altPhoneValidation &&
      altPhoneValidation?.isAltPhoneValid
    ) {
      await saveFinalData(altPhoneValidation, validationEmail);
    } else {
      if (personalInformationErrors.email === '* Invalid Format') {
        const emailElement = document.getElementById('email');
        emailElement.setSelectionRange(0, personalInformation.email?.length);
        emailElement.focus();
      } else {
        setIsValidating(false);
        personalFocusError();
      }
      setIsValidating(false);
    }
  };

  /**
   * Handle continue button */
  const handleContinue = async (e) => {
    e.preventDefault();
    setIsValidating(true);

    let validCheck = isFormValid();

    if (
      // personalInformation?.vouchedIdData?.success &&
      personalInformation?.vouchedJobId !== '' &&
      productMapping(productName) === LIBRE_AHORRA_BUNDLE &&
      !isScreenTwoDirty
    ) {
      setIsValidating(false);
      setIsScreenTwoDirty(false);
      if (personalInformation?.uploadSuccessStatus) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/address-info`
        );
      } else {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/vouched-success`
        );
      }
      return;
    }
    if (isScreenTwoDirty) {
      let altPhoneValidation = null;
      let validationEmail;
      if (productMapping(productName) === PROGRESA_CONTIGO) {
        if (
          personalInformation?.phone &&
          checkInvalidMobileNumber(personalInformation?.phone, leadGenerationContext)
        ) {
          validCheck = false;
          setPersonalInformationErrors((prevState) => ({
            ...prevState,
            phone: '* Invalid Phone',
          }));
        } else if (!personalInformationErrors?.phone) {
          altPhoneValidation = await validateMobile(
            personalInformation?.areaCode,
            'phone',
            personalInformation?.phone,
            productName
          );
          validCheck = altPhoneValidation?.isAltPhoneValid && validCheck;
        }
      }
      if (
        personalInformation?.altPhone &&
        personalInformation?.altAreaCode &&
        checkInvalidMobileNumber(personalInformation?.altPhone, leadGenerationContext) &&
        productMapping(productName) !== PROGRESA_CONTIGO
      ) {
        validCheck = false;
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          altPhone: '* Invalid Phone',
        }));
      } else if (
        !personalInformationErrors?.altPhone &&
        productMapping(productName) !== PROGRESA_CONTIGO
      ) {
        altPhoneValidation = await validateMobile(
          personalInformation?.altAreaCode,
          'altPhone',
          personalInformation?.altPhone,
          productName
        );
        validCheck = altPhoneValidation?.isAltPhoneValid && validCheck;
      }
      if (
        isCDIraproduct(productName) &&
        cdFlowOffers?.iraType !== 'CD IRA Roth' &&
        personalInformation?.dob &&
        personalInformation?.vouchedJobId
      ) {
        const dob = new Date(personalInformation.dob);
        const age = differenceInYears(date.currentDateInPR, dob);
        if (age === 75) {
          validCheck = false;
          setOpenCDIraModal(true);
          setCdIraModalContent({
            heading: 'You are only eligible to open a CD IRA for the previous tax year',
            text1:
              'Due to your age (75 or older), it is not possible to open a CD IRA for the current tax year.',
            text2: 'Click Continue to proceed with opening your CD IRA for the previous tax year.',
            button2: 'Continue',
            button2OnClick: async () => {
              setCardsList([
                {
                  text: `${date?.year - 1} tax year`,
                  id: 'priorTaxYear',
                },
              ]);
              setProductDataIRA((prevState) => ({
                ...prevState,
                yearStatus: {
                  text: `${date?.year - 1} tax year`,
                  id: 'priorTaxYear',
                },
              }));
              setOpenCDIraModal(false);

              saveCall({ validCheck, altPhoneValidation, validationEmail });
            },
            onClose: () => {
              setOpenCDIraModal(false);
            },
          });

          saveKnockOffData(leadGenerationContext, AGE_LIMIT_CD_IRA);
        } else if (age > 75) {
          validCheck = false;
          setOpenCDIraModal(true);
          setCdIraModalContent({
            heading: 'You are not eligible to open a CD IRA',
            text1: 'Due to your age (75 or older), it is not possible to open a CD IRA account.',
            text2: 'Discover how our Certificates of Deposit can help your money grow.',
            alertIcon: true,

            button1: 'Learn more about CDs',
            button1OnClick: () => {
              window.open(
                'https://orientalbank.com/en/for-you/banking-accounts/certificates-of-deposit',
                '_blank'
              );
            },
            button2: 'Open a CD',
            button2OnClick: () => {
              clearContext(leadGenerationContext);
              setApplicationId(null);
              leadGenerationContext.setCdFlowOffers({
                depositAmount: '',
                minDepositAmount: 1000,
                offers: {},
                iraType: '',
              });
              leadGenerationContext.setAccessToken(accessToken);
              leadGenerationContext.setLanguage(language);
              setProductName('Certificate of Deposit');

              setProductType('Certificate of Deposit');
              setFlowTypeETB(flowTypeETB);
              history.push({
                pathname: `/${location?.toLowerCase()}/${language.toLowerCase()}/retail-form/${productNameURLMapping(
                  'Certificate of Deposit'
                )}/certificate-of-deposit`,
              });
            },
          });
          saveKnockOffData(leadGenerationContext, AGE_LIMIT_CD_IRA);
        }
      }
      if (validCheck) {
        await saveCall({ validCheck, altPhoneValidation, validationEmail });
      } else {
        setIsValidating(false);
        personalFocusError();
      }
    } else {
      setIsValidating(false);
      setIsScreenTwoDirty(false);
      if (personalInformation?.uploadSuccessStatus) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/address-info`
        );
      } else {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/vouched-success`
        );
      }
    }
    setIsValidating(false);
  };

  const saveCall = async ({ validCheck, altPhoneValidation, validationEmail }) => {
    /**
     * call save api only if both form and mobile valid */

    const ssnId = personalInformation.ssn;
    const ssnId2 = ssnId.replace(/-/g, '');

    if (productMapping(productName)) {
      const customerValidation = await getCustomerValidation(ssnId2, leadGenerationContext);
      await handleCustomerValidation(
        validCheck,
        customerValidation,
        altPhoneValidation,
        validationEmail
      );

      setCustomerType(customerValidation?.data?.CustomerType || 'NTB');
      if (!leadGenerationContext.savedDataFlow) {
        if (personalInformation.oldssn !== personalInformation.ssn) {
          identifyCustomerType(
            leadGenerationContext,
            productName,
            customerValidation?.data?.CustomerType || 'NTB'
          );
        }
      }
    } else {
      await saveFinalData(altPhoneValidation, validationEmail);
    }
  };

  /**
   *Navigate to vouched screen when user click id upload icon */
  const vouchedTigger = () => {
    // if (!idUploadStatus) {
    history.push(
      `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
        productName
      )}/vouched`
    );
    // }
  };

  const personalBundle = () => (
    <NewLayout
      ariaDescribedby="screenTwoDesc"
      headingId="screenTwoHeading"
      ariaDescribedbyId="screenThreeDesc"
      classes={classes}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Personal Info Text Prog'
          : 'Personal Info Text'
      }
      descriptionValue={
        productMapping(productName) === 'Elite Account'
          ? PERSONAL_INFO_HEAD_PROG
          : PERSONAL_INFO_HEAD
      }
      stepValue={0}
      handleBack={handleBack}
      handleContinue={handleContinue}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating || idUploadStatus === false || bundleErrorModal}
      backBtnTestid="back-button"
      continueBtnTestid="handle-continue"
      screenLoading={isValidating || isValidatingVouch}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN || productMapping(productName) === 'Ahorra'
          ? EliteImage
          : RetailImage1
      }
    >
      <div role="main" aria-describedby="screenTwoHeading">
        {/* Child component */}
        <PersonalBundle handleChange={handleChange} vouchedTigger={vouchedTigger} />
        {/* Populate modal when user upload other than US, PR, USVI, VI country ID's */}
      </div>
    </NewLayout>
  );

  const personal = () => (
    <Layout
      ariaDescribedby="screenTwoDesc"
      headingId="screenTwoHeading"
      ariaDescribedbyId="screenThreeDesc"
      classes={classes}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Personal Info Text Prog'
          : 'Personal Info Text'
      }
      descriptionValue={
        productMapping(productName) === 'Elite Account'
          ? PERSONAL_INFO_HEAD_PROG
          : PERSONAL_INFO_HEAD
      }
      stepValue={1}
      handleBack={handleBack}
      handleContinue={handleContinue}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating || idUploadStatus === false}
      backBtnTestid="back-button"
      continueBtnTestid="handle-continue"
      screenLoading={isValidating || isValidatingVouch}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN ||
        productMapping(productName) === 'Ahorra' ||
        isSimilarIRAProducts(productName)
          ? EliteImage
          : RetailImage1
      }
    >
      <div role="main" aria-describedby="screenTwoHeading">
        {/* Child component */}
        <Personal handleChange={handleChange} vouchedTigger={vouchedTigger} />
        {/* Populate modal when user upload other than US, PR, USVI, VI country ID's */}
      </div>
    </Layout>
  );
  const personalInfoJsx = commonTernary(isBundle(productName), personalBundle(), personal());
  const modalTextKey = productsNotEligibleForUsAddress(productName) ? '' : 'COUNTRY_MODAL_TEXT';
  const modalDefaultValue = productsNotEligibleForUsAddress(productName) ? '' : MSG_COUNTRY_MODAL;

  return (
    /**
     * PersonalInformation screen 2 product name and heading JSX content */
    <>
      {personalInfoJsx}

      {countryModal && (
        <CommercialModal
          message={t(modalTextKey, { defaultValue: modalDefaultValue })}
          vouchedModal
          openModal={countryModal && !isBundle(productName)}
        />
      )}
      {vouchedFailModal && !isBundle(productName) && (
        <CommercialModal
          message={t(`MSG_VOUCHED_MODAL`, { defaultValue: MSG_VOUCHED_MODAL })}
          vouchedModal
          openModal={vouchedFailModal}
        />
      )}
      <KnockOffModal
        message={{ message: KNOCK_OFF_MSSG_BODY, isKnockOff: true }}
        setIsModal={setIsModal}
        openModal={isModal && !isBundle(productName)}
      />
      <BundleErrorModal
        message={
          countryModal
            ? { errorTitle: MODALTEXTHEADING }
            : {
                errorHead: VOUCHED_ERROR,
                errorTitle: NOT_ELIGIBLE,
                errorDescription: NOT_ELIGIBLE_DESCRIPTION,
              }
        }
        setIsModal={isModal && setIsModal}
        openModal={(isModal || bundleErrorModal) && isBundle(productName)}
      />
      {isModalSave && <SaveContinueModal />}
      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage={PERSONAL_INFO} />
      )}
      <CDIRAModals
        openCDIraModal={openCDIraModal}
        setOpenCDIraModal={setOpenCDIraModal}
        content={cdIraModalContent}
      />
    </>
  );
}

export default withRouter(PersonalInformation);

PersonalInformation.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
